import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Tag, Typography } from "antd";
import axios from "axios";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";

const { Title } = Typography;

const TrainingRequestList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/TrainingRequest/Manager/List`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "*/*",
            },
          }
        );
        setRequests(response.data);
      } catch (error) {
        console.error("Failed to fetch training requests:", error);
        message.error("Failed to load training requests");
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [token]);

  return (
    <Card title="Training Requests" loading={loading} className="card-professional">

      <Row
        gutter={[16, 16]}
        style={{
          pointerEvents: isBlocked ? "none" : "auto",
          opacity: isBlocked ? 0.6 : 1
        }}
      >
        {requests.map((req) => (
          <Col xs={24} sm={14} md={10} lg={8} key={req.id}>
            <Card bordered={false} style={{ boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}>
              <Title level={5} style={{ marginBottom: 16 }}>
                <strong>Employee ID :</strong> {req.learnerId}
              </Title>
              <Title level={5} style={{ marginBottom: 16 }}>
                <strong>Employee Name :</strong> {req.learnerName}
              </Title>
              <p>
                <strong>Course:</strong> {req.courseTitle}
              </p>

              <p>
                <strong>Status:</strong>{" "}
                <Tag color={req.status === 2 ? "green" : "orange"}>
                  {req.status === 2 ? "Approved" : "Pending"}
                </Tag>
              </p>
              <p>
                <strong>Training Recommended on : </strong>  {new Date(req.createdOn).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'

                })}
              </p>
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default TrainingRequestList;
